import type { ScopeView } from "@nabla/api";
import { place } from "./place.ts";

export const overview = (view: ScopeView) => {
  const section = view.modules?.["growth-planning"];
  if (section === undefined) return undefined;
  return { title: "Escala", lead: section.lead, lines: section.lines, origin: section.origin, href: place.path };
};
